import React from 'react';
import { HOLDING_BRAND_NAMES } from '../constants/holdingBrands';
import './BrandLandingPage.css';

/** Landing pública Atelier — sin menciones internas a agentes. */
const ProductStudioLanding = () => {
  const brand = HOLDING_BRAND_NAMES.productStudio;
  const go = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <main className="brand-landing brand-landing--live">
      <div className="brand-landing-hero" aria-hidden="true">
        <div className="brand-landing-hero-geo" />
      </div>

      <div className="brand-landing-inner">
        <p className="brand-landing-eyebrow">Javiland · Servicios</p>
        <h1 className="brand-landing-title">{brand.name}</h1>
        <p className="brand-landing-tagline">{brand.tagline}</p>
        <p className="brand-landing-body">{brand.pitch}</p>

        <ul className="brand-landing-chips">
          {(brand.highlights || []).map((h) => (
            <li key={h}>{h}</li>
          ))}
        </ul>

        <div className="brand-landing-panel">
          <p className="brand-landing-body" style={{ marginBottom: '1.25rem' }}>
            Si querés una web, una tienda o un ecosistema completo con operación y evolución
            en el tiempo — Atelier es el canal. Escribínos y contanos tu idea.
          </p>
          <div className="brand-landing-actions">
            <a
              className="brand-landing-cta"
              href="mailto:studio@javiland.com?subject=Quiero%20hablar%20con%20Atelier"
              style={{ textDecoration: 'none' }}
            >
              Escribir a Atelier
            </a>
            <button
              type="button"
              className="brand-landing-cta brand-landing-cta--ghost"
              onClick={() => go('/proyectos')}
            >
              Ver proyectos del holding
            </button>
          </div>
          <button type="button" className="brand-landing-link" onClick={() => go('/')}>
            Volver al hub Javiland
          </button>
        </div>
      </div>
    </main>
  );
};

export default ProductStudioLanding;
